import React, { forwardRef } from 'react';
import styles from './TextArea.module.scss';

export default forwardRef((props, ref) => {
  return <textarea className={styles.textarea} ref={ref} {...props} />;
});
